import { TimeZoneType } from "../../constants/timezones"
import { DateOrderOptionType, DateSeparatorOptionType } from "../../utils/date-format"
import { AccountStatus } from "../../types/common"
import { Language } from "../../utils/languages"
import { IUserResponse } from "./user-response"

export const normalizeUser = (user: IUserResponse): IUserNormalized => {
  const isActive = user.accountStatus === AccountStatus.ACTIVE
  const isWaitingVerification = user.accountStatus === AccountStatus.WAITING_VERIFICATION
  const isDeactivated = user.accountStatus === AccountStatus.DEACTIVATED

  return {
    ...user,
    isActive,
    isWaitingVerification,
    isDeactivated,
  }
}

export interface IUserNormalized {
  id: string
  createdAt: string
  updatedAt: string
  firstname: string
  lastname: string
  fullname: string
  initials: string
  email: string
  accountStatus: AccountStatus
  avatarURL: string
  weekendDays: DayOfWeek[]
  firstDayOfWeek: DayOfWeek
  timeZone: TimeZoneType
  dateFormatSeparator: DateSeparatorOptionType
  dateFormat: DateOrderOptionType
  isActive: boolean
  isWaitingVerification: boolean
  isDeactivated: boolean
  language: Language
}
